import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Vehicle } from '@sm360/widget-commons-vehicle';
import * as actions from 'inventory-listing/actions/listingUsedActions.js';

function mapStateToProps(state, ownProps) {
    return {
        paymentOptions: state.listingUsed.paymentOptions,
        tradeInVehicle: state.tradeInVehicle,
        ownProps,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        tradeInActions: bindActionCreators(Vehicle.TradeInVehicleActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Vehicle.PaymentOptionFilters);
